module.exports = require("W:\\CODE\\js\\_ports\\port\\config\\typography.js")


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-typography/.cache/typography.js
// module id = 552
// module chunks = 231608221292675